module.exports = __webpack_public_path__ + "img/logo-white.9a098de0.png";